export class CompanyFeature {
  public id: number | null;
  public company_id: number | null;
  public feature_id: number;

  constructor(data: CompanyFeatureData | undefined | null = undefined) {
    if (data === undefined || data === null) {
      this.id = null;
      this.company_id = null;
      this.feature_id = -1;
    }
    else {
      this.id = data.id;
      this.company_id = data.company_id;
      this.feature_id = data.feature_id;
    }

  }

  serializeData():CompanyFeatureData {
    return {
      id: this.id,
      company_id: this.company_id,
      feature_id: this.feature_id,
    }
  }
}

export type CompanyFeatureData = {
  id: number | null;
  company_id: number | null;
  feature_id: number;
}
